import React, { useEffect } from 'react';

import Layout from "./components/Layout";
import SEO from "./components/SEO";
import Hero from "./components/Hero";
import BenefitSection from "./components/BenefitSection";
import FAQ from "./components/FAQ";
import Features from "./components/Features";
import TestimonialSection from "./components/TestimonialSection";
import CTA from "./components/CTA";
import HowItWorks from "./components/HowItWorks";

import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {

  useEffect(() => {
    AOS.init({duration: 1200, delay: 200, once:false});
  })  

  return (
    <Layout>
      <SEO title="Home" />
      {/* hero section */}
      <Hero />

      {/* how it works section */}
      <HowItWorks />

      {/* benefits section */}
      <BenefitSection />

      {/* faq section */}
      <FAQ />

      {/* features section */}
      <Features />      

      {/* testimonials section */}
      <TestimonialSection />

      {/* call to action section */}
      <CTA />

    </Layout>
  );
}

export default App;
